module.exports = __webpack_public_path__ + "img/4.e52287c8.jpg";